import $ from 'jquery';
import City from 'portlets/site/order/city/city';
import Animation from 'modules/animation/animation';
import Numbered from 'input.numbered';
import Cookie from 'modules/cookie/cookie';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderMain',
			dom: {
				city: '.js-city',
				name: '#yotaOrderMainCityName',
				express: '#yotaOrderMainExpress',

				tooltip: '#yotaOrderMainTooltip',
				tooltipShow: '#yotaOrderMainTooltipShow',
				tooltipClose: '#yotaOrderMainTooltipClose',

				form: '#yotaOrderMainForm',
				cmd: '#yotaOrderMainCmd',
				cityJson: '#yotaOrderMainCityJson',
				cityId: '#yotaOrderMainCityId',
				cityCode: '#yotaOrderMainCityCode',

				count: '#yotaOrderMainCount',

				phone: '#yotaOrderMainPhone',
				phoneHidden: '#yotaOrderMainPhoneHidden',
				send: '#yotaOrderMainSend',
				order: '#yotaOrderMainOrder',

				code: '#yotaOrderMainCode',

				resend: '#yotaOrderMainResend',

				submit: '#yotaOrderMainSubmit'
			},
			classes: {
				find: 'b-order-main_state_find',
				express: 'b-order-main_state_express',
				tooltip: 'b-order-main__tooltip_state_open',
				phoneError: 'b-order-main_phone_error',
				phoneSend: 'b-order-main_phone_send',
				wait: 'b-order-main_state_wait',
				codeError: 'b-order-main_code_error',
				codeOk: 'b-order-main_code_ok'
			},
			callback: {
				set: false,
				express: false,
				sms: false
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$document = $(document);

		this.send = false;
		this.timer = 0;
		this.interval = false;
		this.sms = false;
		this.cmd = 'send';
		this.cookie = new Cookie();

		return this;
	}

	getDom() {
		this.$city = this.$el.find(this.options.dom.city);
		this.$name = this.$el.find(this.options.dom.name);
		this.$express = this.$el.find(this.options.dom.express);

		this.$tooltip = this.$el.find(this.options.dom.tooltip);
		this.$tooltipShow = this.$el.find(this.options.dom.tooltipShow);
		this.$tooltipClose = this.$el.find(this.options.dom.tooltipClose);

		this.$form = this.$el.find(this.options.dom.form);
		this.$cmd = this.$el.find(this.options.dom.cmd);
		this.$cityJson = this.$el.find(this.options.dom.cityJson);
		this.$cityId = this.$el.find(this.options.dom.cityId);
		this.$cityCode = this.$el.find(this.options.dom.cityCode);

		this.$count = this.$el.find(this.options.dom.count);

		this.$phone = this.$el.find(this.options.dom.phone);
		this.$phoneHidden = this.$el.find(this.options.dom.phoneHidden);
		this.$send = this.$el.find(this.options.dom.send);
		this.$order = this.$el.find(this.options.dom.order);

		this.$code = this.$el.find(this.options.dom.code);

		this.$resend = this.$el.find(this.options.dom.resend);

		this.$submit = this.$el.find(this.options.dom.submit);

		return this;
	}

	setCity(data) {
		this.$el.removeClass(this.options.classes.find);
		this.$name.html(data.name);
		this.$el.toggleClass(this.options.classes.express, data.deliveryExpress);
		this.$express.prop('checked', !!data.deliveryExpress);

		this.$cityJson.val(JSON.stringify(data));
		this.$cityId.val(data.id);
		this.$cityCode.val(data.code);
	}

	setCount(count) {
		this.$count.val(count);
	}

	onCitySet(data) {
		if (typeof this.options.callback.set == 'function') {
			this.options.callback.set(data, 'main');
		}
	}

	find(event) {
		event.preventDefault();
		this.$el.addClass(this.options.classes.find);
		this.city.focus();
	}

	tooltipShow() {
		this.$tooltip.toggleClass(this.options.classes.tooltip);
	}

	tooltipClose() {
		this.$tooltip.removeClass(this.options.classes.tooltip);
	}

	onDocumentTooltipClick(event) {
		const $target = $(event.target);
		if (this.$tooltip.hasClass(this.options.classes.tooltip)) {
			if (!$target.is(this.$tooltip) && !$target.closest(this.$tooltip).length) {
				this.tooltipClose();
			}
		}
	}



	validate() {
		let valid = true;
		if (this.$phone.length) {
			const phone = this.$phone.val().replace(/[^\d]/gi, '');
			if (phone.length < 11) {
				this.$el.addClass(this.options.classes.phoneError);
				$(() => new Animation({el: this.$phone.parent()}).play('shake'));
				valid = false;
			}
		}

		if (this.$code.length && this.$el.hasClass(this.options.classes.phoneSend)) {
			const code = this.$code.val().replace(/[^\d]/gi, '');
			if (code.length < 3) {
				this.$el.addClass(this.options.classes.codeError);
				$(() => new Animation({el: this.$code.parent()}).play('shake'));
				valid = false;
			}
		}

		return valid;
	}

	onSend(event) {
		event.preventDefault();
		const valid = this.validate();
		if (valid) {
			this.$form.submit();
		}
	}

	onSubmit(event) {
		event.preventDefault();

		const self = this;
		const valid = self.validate();

		if (!valid) {
			return false;
		}

		if (!self.send && valid) {
			if (self.cmd === 'send') {
				self.send = true;
				self.$cmd.val('send');
				self.$phoneHidden.val(this.$phone.val());
				$.ajax({
					url: self.$form.attr('action'),
					type: self.$form.attr('method'),
					data: self.$form.find(':input').serialize(),
					dataType: 'json',
					success: function (json) {
						if (json && json.success && json.order) {
							self.cmd = 'order';
							self.$order.val(json.order);
							self.$el.addClass(self.options.classes.phoneSend);
							self.$phone.prop('disabled', true);
							self.$code.prop('disabled', false);
							self.startTimer(json.time || self.$resend.data('time') || 60);
						} else {
							self.$el.addClass(self.options.classes.phoneError);
							$(() => new Animation({el: self.$phone.parent()}).play('shake'));
						}
						self.send = false;
					}
				});

				if (typeof this.options.callback.sms == 'function') {
					this.options.callback.sms('send', 'main');
				}
			}
			if (self.cmd === 'order') {
				self.send = true;
				self.$cmd.val('order');
				$.ajax({
					url: self.$form.attr('action'),
					type: self.$form.attr('method'),
					data: self.$form.find(':input').serialize(),
					dataType: 'json',
					success: function (json) {
						if (json && json.success) {
							if (json.analytics && json.location) {
								self.cookie.set('checkoutEvent8_1', encodeURIComponent(json.analytics['event']), 365);
								self.cookie.set('checkoutEvent8_2', encodeURIComponent(json.analytics['NAME']), 365);
								self.cookie.set('checkoutEvent8_3', encodeURIComponent(json.analytics['ID_PRODUCT']), 365);
								self.cookie.set('checkoutEvent8_4', encodeURIComponent(json.analytics['CATEGORY']), 365);
								self.cookie.set('checkoutEvent8_5', encodeURIComponent(json.analytics['PRICE']), 365);
								self.cookie.set('checkoutEvent8_6', encodeURIComponent(json.analytics['QUANTITY']), 365);
								self.cookie.set('checkoutEvent8_7', encodeURIComponent(json.analytics['Город доставки']), 365);
								self.cookie.set('checkoutEvent8_8', encodeURIComponent(json.analytics['Способ доставки']), 365);
								self.cookie.set('checkoutEvent8_9', encodeURIComponent(json.analytics['ID_TRANSACTION']), 365);
								self.cookie.set('checkoutEvent8_10', encodeURIComponent(json.analytics['REVENUE']), 365);
							}
							if (json.location) {
								window.location.assign(json.location);
							}
						} else {
							self.$el.addClass(self.options.classes.codeError);
							$(() => new Animation({el: self.$code}).play('shake'));
							self.$submit.prop('disabled', true);
						}
						self.send = false;
					}
				});
			}
		}
	}

	updateTimer() {
		let {text} = this.$resend.data();
		text = text.replace('{{=time}}', this.timer);
		this.$resend.html(text);
	}

	startTimer(time) {
		this.timer = time - 1;
		this.updateTimer();
		this.$el.addClass(this.options.classes.wait);
		clearInterval(this.interval);
		this.interval = setInterval(this.stopTimer.bind(this), 1000);
		return this;
	}

	stopTimer() {
		this.timer--;
		this.updateTimer();
		if (this.timer <= 0) {
			this.$el.removeClass(this.options.classes.wait);
			const {send} = this.$resend.data();
			this.$resend.html(send);
			clearInterval(this.interval);
		}
		return this;
	}

	onPhoneFocusIn() {
		this.$el.removeClass(this.options.classes.phoneError);
	}

	onInput(event) {
		const $target = $(event.currentTarget);
		this.$el.removeClass(this.options.classes.codeError);
		const val = $target.val();
		if (val.length > 4) {
			$target[0].value = val.substr(0, 4);
		}
		this.$el.toggleClass(this.options.classes.codeOk, val.length >= 4);
		this.$submit.prop('disabled', val.length < 4);
	}

	onResend() {
		const self = this;
		event.preventDefault();
		if (!self.send) {
			self.send = true;
			self.$cmd.val('resend');
			$.ajax({
				url: self.$form.attr('action'),
				type: self.$form.attr('method'),
				data: self.$form.find(':input').serialize(),
				dataType: 'json',
				success: function (json) {
					if (json && json.success) {
						self.startTimer(json.time || self.$resend.data('time') || 60);
					}
					self.send = false;
				}
			});
		}

		if (typeof this.options.callback.sms == 'function') {
			this.options.callback.sms('resend', 'main');
		}
	}

	onExpress() {
		if (typeof this.options.callback.express == 'function') {
			this.options.callback.express(this.$express.prop('checked'), 'main');
		}
	}

	getExpress() {
		return this.$express.prop('checked');
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();

			self.city = new City({
				el: self.$city,
				callback: {
					set: self.onCitySet.bind(self)
				}
			}).render();

			self.numbered = new Numbered(self.$phone, {placeholder: false});

			self.$name.on('click', self.find.bind(self));

			self.$tooltipShow.on('click', self.tooltipShow.bind(self));
			self.$tooltipClose.on('click', self.tooltipClose.bind(self));

			self.$document.on('click.order.main', self.onDocumentTooltipClick.bind(self));

			self.$send.on('click', self.onSend.bind(self));
			self.$form.on('submit', self.onSubmit.bind(self));

			self.$phone.on('focusin', self.onPhoneFocusIn.bind(self));
			this.$code.on('change input blur keypress focus', self.onInput.bind(self));
			this.$resend.on('click', self.onResend.bind(self));

			this.$express.on('change', self.onExpress.bind(self));
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order/main/main.js